// export interface IncomingMessage {
//     type: 'IncomingMessage'
//     text: string
// }
//
// export interface OutgoingMessage {
//     type: 'OutgoingMessage'
//     text: string
// }
import { Moment } from '@/entities/moment'
import { IResponse } from '@/entities/response'

export const VISIBILITY_EVERYONE = 0
export const VISIBILITY_PRIVATE = 1
export const VISIBILITY_LOCATION = 2

export interface InitialMessage {
    id: string
    type: 'initial'
    text: string
    outgoing: number
}

export interface NoteMessage {
    id: string
    type: 'note'
    text: string
    outgoing: number
}

export interface WorkflowMessage {
    id: string
    type: 'automation'
    text: string
    outgoing: number
}

export type ChatMessage = (InitialMessage | NoteMessage | WorkflowMessage) & {
    review_replied: number
    time: string
    notice_id?: number
}

export type FeedbackDetailMessage = Moment | IResponse

export interface ChatTemplate {
    id: string | number
    name: string
    subject: string
    text: string
    calendly?: {
        link?: string
        text?: string
    }
    raw_text?: string // raw template text without replacing variables
    raw_subject?: string // raw template subject without replacing variables
    permanent?: string // '0' | '1'
    sent?: string // '0' | '1'
    private?: number
    canEdit?: boolean
    canDelete?: boolean
    visibilityLocations?: number[]
}

export interface ChatWorkflow {
    automatic: string
    name: string
    id: string
    type: string
}

export interface ChatStatus {
    note: string // note text
    reply: string // reply text
    reply_from?: string
    reply_subject?: string
    editing: number // 0 - not editing, 1 - replying, 2 - noting, 3 - shout-out
    reply_review: boolean // if publish reply to review
    editing_template: number // the chat template id we are editing
}

export interface ChatMention {
    name: string
    email: string
}

// object to send back to add chat reply
export interface ChatReply {
    subject: string
    from_name: string
    message: string
    publishReview: string
    closecase?: string
    caseClosedOption?: string
    template_id?: string
}

export interface EmojiReactions {
    [emoji: string]: string[]
}

export interface EmojiReactionDetails {
    emoji: string
    count: number
    self: boolean
}

export interface EmojiReactionRequest {
    type: string | 'note' | 'question' | 'chat'
    relid: number
}

export interface ChatTags {
    tags: string[]
}

export interface IAtMember {
    name: string
    email: string
}
